import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gfu-team-member-card__media gfu-embed gfu-embed--1x1" }
const _hoisted_2 = { class: "gfu-team-member-card__content" }
const _hoisted_3 = { class: "gfu-hd gfu-hd--h3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_base_carousel_navigation = _resolveComponent("base-carousel-navigation")
  const _component_base_carousel = _resolveComponent("base-carousel")

  return ($props.members.length > 0)
    ? (_openBlock(), _createBlock(_component_base_carousel, {
        key: 0,
        autoplay: true,
        items: $props.members,
        class: "gfu-base-carousel",
        onChange: $options.onChange
      }, {
        view: _withCtx(() => [
          _createVNode(_TransitionGroup, {
            name: $options.transitionName,
            class: "gfu-team-members",
            tag: "div"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.slides, (slide) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: slide.name,
                  class: _normalizeClass(['gfu-team-member-card'])
                }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_themed_image, {
                      class: "gfu-embed__item",
                      src: slide.imageUrl,
                      alt: slide.name
                    }, null, 8 /* PROPS */, ["src", "alt"])
                  ]),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h4", _hoisted_3, _toDisplayString(slide.name), 1 /* TEXT */),
                    _createElementVNode("div", null, _toDisplayString(slide.position), 1 /* TEXT */)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["name"])
        ]),
        nav: _withCtx(({ onNext, onPrev }) => [
          _createVNode(_component_base_carousel_navigation, {
            type: "prev",
            icon: "angle-left",
            class: "gfu-partners-slider-nav--prev",
            onClick: onPrev
          }, null, 8 /* PROPS */, ["onClick"]),
          _createVNode(_component_base_carousel_navigation, {
            type: "next",
            icon: "angle-right",
            class: "gfu-partners-slider-nav--next",
            onClick: onNext
          }, null, 8 /* PROPS */, ["onClick"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["items", "onChange"]))
    : _createCommentVNode("v-if", true)
}